module.exports = __webpack_public_path__ + "static/dashboard-freemium-2-6b3d0edef55eeabc859ed9e428024ecf.png";